import { render, staticRenderFns } from "./ztfx.vue?vue&type=template&id=110d9c28&scoped=true"
import script from "./ztfx.vue?vue&type=script&lang=js"
export * from "./ztfx.vue?vue&type=script&lang=js"
import style0 from "./ztfx.vue?vue&type=style&index=0&id=110d9c28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110d9c28",
  null
  
)

export default component.exports